import TemplateView from '../../../../TemplateView'
import messageResource from '../../../../messageResource'
import {DateFormat} from '../../../../date_format'
import {purchaseStep} from '../../constants'

export default class SwitchToFreeLightBoxHeader extends TemplateView {
    constructor() {
        super()

        this.state = {
            purchaseStep: '',
            startDate: '',
        }

        this.onStatePropertyChanged('purchaseStep', (step) => {
            this.$switchToFreeTitle.toggle(step === purchaseStep.SWITCH_TO_FREE)
        })

        this.onStatePropertyChanged('startDate', (startDate) => {
            this.$switchToFreeTitle.text(messageResource.getMessage('licenses.switch_to_free.header', [this.dateFormatter.formatDate(startDate)]))
        })
    }

    templateHtml() {
        return '<div class="header">' +
               '    <div class="switchToFreeTitle"/>' +
               '    <div class="closeButton"/>' +
               '</div>'
    }

    afterRender() {
        this.$switchToFreeTitle = this.find('.switchToFreeTitle')
        this.dateFormatter = new DateFormat('MMM dd')
    }

    getCloseButtonEl() {
        return this.find('.closeButton')
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/switchToFreeLightBox/SwitchToFreeLightBoxHeader.js